import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const LeaseRoot = () => {
  return (
    <AdminRouteLayout>
      <Outlet />
    </AdminRouteLayout>
  );
};

export default LeaseRoot;
